import { MantineSize, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { Group } from '../../Layout';
import { TransitionElement } from '../../Miscellaneous';
import { Affix } from '../../Overlays';

type Props = {
  children?: React.ReactNode;
  mobileBreakpoint?: MantineSize;
};

export const MobileBottomButton = ({ children, mobileBreakpoint = 'md' }: Props) => {
  const theme = useMantineTheme();
  const isSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints[mobileBreakpoint]})`);

  if (!children) return null;

  return (
    <Affix left={'0'} right={0} withinPortal={false}>
      <TransitionElement mounted={!!isSmallScreen}>
        <Group grow p="md" bg="linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 35.23%)">
          {children}
        </Group>
      </TransitionElement>
    </Affix>
  );
};
